module.exports = "<label class=checkbox-label><input type=checkbox class=public-radio-btn ng-model=model name={{inputName}} ng-true-value=1 ng-false-value=0> <i class=\"fa fa-check-square-o checkbox-icon not-printable\" ng-show=model></i> <i class=\"fa fa-square-o checkbox-icon not-printable\" ng-show=!model></i> <span class=checkbox-text ng-transclude></span></label>";


/*****************
 ** WEBPACK FOOTER
 ** ./client/components/checkbox/checkbox.html
 ** module id = 146
 ** module chunks = 0
 **/